import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { User } from "../models/User";
import { Customer } from "../models/Customer";
import { Observable } from "rxjs";
import { SalesUser } from "../models/SalesUser";

export interface UserMeResponse {
    userType: 'customer' | 'sales' | 'employee';
    user: User;
    customer?: Customer;
    salesUser?: SalesUser; // Define SalesUser model if needed
    roles: string[];
}

@Injectable({
    providedIn: 'root',
})
export default class UserService {
    baseUrl = `${environment.backend.baseUrl}${environment.backend.apiUrl}/`;
    constructor(private http: HttpClient) { }

    /**
     * Universal user identity endpoint
     * Auto-creates User + Customer (if Customer role + CIAM)
     * Auto-creates User + SalesUser (if Sales role + Employee)
     * Returns User only (if other employee roles)
     */
    getMe(): Observable<UserMeResponse> {
        return this.http.get<UserMeResponse>(`${this.baseUrl}User/me`);
    }
}